module.exports = __webpack_public_path__ + "static/media/signage-indoor-img21.e45a2bae.jpg";